import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { fetchFeed } from '../redux/feedInfiniteSlice'
import { deleteMyRoom } from '../redux/apis'

import { setShowPurchaseCoins } from '../redux/designerReducers/designerReducer'

import Detail from '../components/DesignerCommon/Detail'
import Feed from '../components/DesignerFeed/Feed'
import DesignFeedContainer from '../components/DesignerDesigns/DesignFeedContainer'
import DesignMyRoomCard from '../components/DesignerDesigns/cards/DesignMyRoomCard'
import DesignFeedCard from '../components/DesignerDesigns/cards/DesignFeedCard'
import DesignUploadMyRoomCard from '../components/DesignerDesigns/cards/DesignUploadMyRoomCard'
import DeleteConfirmation from '../components/DesignerModals/DeleteConfirmation'

import CropRoomModal from '../components/DesignerModals/CropRoomModal'
import MyRoomMaxedModal from '../components/DesignerModals/MyRoomMaxedModal'
import { FEED_RESET } from '../redux/constants'
import { logEvent } from '../utils/firebase'
import { getMembershipType } from '../utils/getMembershipType'
import { useDecor } from '../context/decor'

const Card = props => {
  return (
    <DesignFeedCard>
      <DesignMyRoomCard {...props}></DesignMyRoomCard>
    </DesignFeedCard>
  )
}

const AddCard = props => {
  return (
    <DesignFeedCard>
      <DesignUploadMyRoomCard {...props}></DesignUploadMyRoomCard>
    </DesignFeedCard>
  )
}

const MyRooms = () => {
  const dispatch = useDispatch()
  const { homeMyRoomUploadImageFile, setHomeMyRoomUploadImageFile } = useDecor()

  //const { myrooms, myroomInfo, loading, error } = useSelector(state => state.myroom)
  const profile = useSelector(state => state.profile.me)
  const { feed: myrooms, loading, error, root } = useSelector(state => state.myroom)
  const membershipInfo = getMembershipType(profile)

  const [showCropModal, setShowCropModal] = useState(false)
  const [showMaxedModal, setShowMaxedModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [disableUpload, setDisableUpload] = useState(false)

  const rCrop = useRef()
  //const rMaxed = useRef()

  const [toDelete, setToDelete] = useState()

  useEffect(() => {
    if (homeMyRoomUploadImageFile) rCrop.current.showAndSave(homeMyRoomUploadImageFile)
  }, [])

  useEffect(() => {
    if (membershipInfo.isMember) {
      setDisableUpload(false)

      return
    }

    setDisableUpload(true)
  }, [root, membershipInfo.isMember])

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(fetchFeed('myroom')({ status: FEED_RESET }))
  }, [dispatch])

  const handleDeleteToConfirm = data => {
    setShowDeleteModal(true)
    setToDelete(data)
  }

  const handleDelete = () => {
    if (!toDelete) return

    logEvent('my_room_delete', {
      content_type: 'my_room',
      content_id: toDelete.objectId
    })

    if (!toDelete.objectId) return

    deleteMyRoom(toDelete.objectId).then(() => {
      dispatch(fetchFeed('myroom')({ status: FEED_RESET }))
      setShowDeleteModal(false)
    })
  }

  const handleAddClick = e => {
    setShowMaxedModal(true)
  }

  const handleUpgrade = e => {
    setShowMaxedModal(false)
    logEvent('show_purchase_coin', {
      content_type: 'purchase'
    })
    dispatch(setShowPurchaseCoins(true))
  }

  const handleCrop = img => {
    rCrop.current.setImage(img)
    setShowCropModal(true)
  }

  const handleCropClose = e => {
    setShowCropModal(false)
  }

  const handleCropComplete = img => {
    setShowCropModal(false)
    dispatch(fetchFeed('myroom')({ status: FEED_RESET }))
    if (homeMyRoomUploadImageFile) setHomeMyRoomUploadImageFile()
  }

  return (
    <>
      <CropRoomModal ref={rCrop} show={showCropModal} onComplete={handleCropComplete} onClose={handleCropClose} />
      <MyRoomMaxedModal show={showMaxedModal} count={root && root.numSpaces} onClose={e => setShowMaxedModal(false)} onUpgrade={handleUpgrade} />
      <DeleteConfirmation show={showDeleteModal} title="Delete your room template?" onClose={e => setShowDeleteModal(false)} onDelete={handleDelete}>
        Are you sure you want to delete your room template?
      </DeleteConfirmation>
      <Detail title="Decorate Real Room" backToRoot>
        <DesignFeedContainer>
          <AddCard disable={disableUpload} onCrop={handleCrop} onClick={handleAddClick} />
          <Feed data={myrooms} onDelete={handleDeleteToConfirm} card={Card} loading={loading} error={error} from="/myrooms" end={true} noItemsText="No Room Yet" />
        </DesignFeedContainer>
      </Detail>
    </>
  )
}

export default MyRooms
